module.exports = __webpack_public_path__ + "static/media/dipanshu.8422c7a0.jpg";